import { useEffect, useState } from 'react';
import { SnackbarSeverityType } from '../../../enums';
import { getSchoolClassesConfig } from '../../../apis/schoolConfig';
import { SchoolClassesConfig } from '../../../types/schoolConfigType';

export const useSchoolClassesConfig = (
  schoolId: string | undefined,
  showToast: (msg: string, severity: SnackbarSeverityType) => void
) => {
  const [grades, setGrades] = useState<string[]>([]);

  useEffect(() => {
    if (!schoolId) return;

    getSchoolClassesConfig(schoolId)
      .then((response) => {
        const config: SchoolClassesConfig =
          response.data as unknown as SchoolClassesConfig;
        setGrades(config.grades || []);
      })
      .catch((err) => {
        console.error(err);
        showToast('Failed to load grades.', SnackbarSeverityType.error);
      });
  }, [schoolId, showToast]);

  return grades;
};
